const OnMultipleEdit = function() {
  const ids = this.collection.selected_rows
  this.multipleUserEdit.selected_rows = ids
  this.multipleUserEdit.showModal()
}
export default OnMultipleEdit